import i18n from "../../../../i18n";

/**
 * Ticket section configurations for supplier info page
 * Uses i18n directly so it doesn't need a t function passed in
 */
export const ticketSections = [
	{
		id: "defects",
		title: () => i18n.t("supplier-info.defects-section.title"),
		dataKey: "defects",
		sampleData: [],
		style: {
			amountFieldHeaderClass: "text-end",
			amountFieldCellStyle: {
				textAlign: "right",
			},
		},
	},
	{
		id: "damages",
		title: () => i18n.t("supplier-info.damages-section.title"),
		dataKey: "damages",
		sampleData: [],
		style: {
			amountFieldHeaderClass: "text-end",
			amountFieldCellStyle: {
				textAlign: "right",
			},
		},
	},
	{
		id: "counterclaims",
		title: () => i18n.t("supplier-info.counterclaims-section.title"),
		dataKey: "counterclaims",
		sampleData: [],
		style: {
			amountFieldHeaderClass: "text-end",
			amountFieldCellStyle: {
				textAlign: "right",
			},
		},
	},
	{
		id: "provisionalRetentions",
		title: () =>
			i18n.t("supplier-info.provisional-retention-section.title"),
		dataKey: "provisionalRetentions",
		sampleData: [],
		style: {
			amountFieldHeaderClass: "text-end",
			amountFieldCellStyle: {
				textAlign: "right",
			},
		},
	},
	{
		id: "penalties",
		title: () => i18n.t("supplier-info.penalties-section.title"),
		dataKey: "penalties",
		sampleData: [],
		style: {
			amountFieldHeaderClass: "text-end",
			amountFieldCellStyle: {
				textAlign: "right",
			},
		},
	},
	{
		id: "contractSecurity",
		title: () => i18n.t("supplier-info.contract-security-section.title"),
		dataKey: "contractSecurity",
		sampleData: [],
		style: {
			amountFieldHeaderClass: "text-end",
			amountFieldCellStyle: {
				textAlign: "right",
			},
		},
	},
	{
		id: "warrantyBonds",
		title: () => i18n.t("supplier-info.warranty-bonds-section.title"),
		dataKey: "warrantyBonds",
		sampleData: [],
		style: {
			amountFieldHeaderClass: "text-end",
			amountFieldCellStyle: {
				textAlign: "right",
			},
		},
	},
	{
		id: "corrections",
		title: () => i18n.t("supplier-info.corrections-section.title"),
		dataKey: "corrections",
		sampleData: [],
		style: {
			amountFieldHeaderClass: "text-end",
			amountFieldCellStyle: {
				textAlign: "right",
			},
		},
	},
];
